import React, { useEffect, useState } from 'react';
import { get } from '../utils/api';
import './RecentOrders.css';

const RecentOrders = ({ limit = 6 }) => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchOrders = async () => {
      try {
        const res = await get('/orders');
        if (!mounted) return;
        if (res && res.success) {
          const list = Array.isArray(res.data) ? res.data : [];
          // If API returns most recent first use as-is, otherwise sort by order_date
          const sorted = list.slice().sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
          setOrders(sorted.slice(0, limit));
        }
      } catch (err) {
        console.error('Failed to load recent orders', err);
      }
    };

    fetchOrders();
    return () => { mounted = false; };
  }, [limit]);

  return (
    <div className="recent-orders-container">
      {orders.length === 0 && (
        <div className="recent-orders-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M9 9h6M9 13h3" />
          </svg>
          <p>No recent orders</p>
        </div>
      )}

      {orders.map((o) => (
        <div key={o.order_id} className="recent-order-item">
          <div className="order-left">
            <div className="order-id">#{o.order_id}</div>
            <div className="order-customer">{o.customer_name || 'Guest'}</div>
            <div className="order-date">
              {new Date(o.order_date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>
          <div className="order-right">
            <div className="order-amount">₹{o.total_amount}</div>
            <span className={`order-status status-${(o.status || 'unknown').toLowerCase()}`}>
              {o.status || 'unknown'}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentOrders;
